var React = require('react');

function IconCheckmark (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M42.4039 10.5755C43.1906 11.3508 43.1998 12.6171 42.4245 13.4039L17.3478 38.8493L5.5755 26.9039C4.80018 26.1171 4.80942 24.8508 5.59615 24.0755C6.38288 23.3002 7.64917 23.3094 8.4245 24.0961L17.3478 33.1507L39.5755 10.5961C40.3508 9.80942 41.6171 9.80018 42.4039 10.5755Z","fill":"white"}));
}

IconCheckmark.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = IconCheckmark;

IconCheckmark.default = IconCheckmark;
